import { render, staticRenderFns } from "./PortalZohoDialog.vue?vue&type=template&id=e383d926&scoped=true"
import script from "./PortalZohoDialog.vue?vue&type=script&lang=js"
export * from "./PortalZohoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e383d926",
  null
  
)

export default component.exports